export default __webpack_public_path__ + "static/media/Google.fb498fa0.svg";